"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Tabs = _ref => {
  let {
    tabs,
    active = tabs[0].value,
    onChange = function () {}
  } = _ref;
  // const [activeTab, setActiveTab] = React.useState(active || tabs[0].value);

  // React.useEffect(() => {
  //   onChange(activeTab);
  // }, [activeTab]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex font-size-15px border-bottom"
  }, tabs.map(tab => /*#__PURE__*/_react.default.createElement("a", {
    key: 'tab-' + tab.value,
    className: "pb-035em border-width-2px relative",
    href: tab.href,
    onClick: () => onChange(tab.value)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-05em pb-05em pl-075em pr-075em br-6px hoverable hover:bg-light transition color-text"
  }, tab.name), active === tab.value && /*#__PURE__*/_react.default.createElement("div", {
    className: "active-tab"
  }))));
};
var _default = exports.default = Tabs;